import { useState } from 'react'
import Button from '@/components/button'
import FormField from '@/components/form-field'
import { Input } from '@/components/input'
import AuthLayout from '@/layouts/auth-layout'
import { AuthApi } from '@/services/api-routes'
import type { LoginAutenticado } from '@/types/auth'
import { loginAutenticado } from '@/types/auth'
import { notifyErrorFor, notifySuccess } from '@/utility/notify'
import styles from './style.module.css'

interface TwoFactorProps {
  desafio: string
  email: string
  onCancel: () => void
  onVerified: (login: LoginAutenticado) => void
}

const TwoFactor = ({ desafio, email, onCancel, onVerified }: TwoFactorProps) => {
  const [codigo, setCodigo] = useState('')
  const [isVerifying, setIsVerifying] = useState(false)
  const [isResending, setIsResending] = useState(false)

  const validar = async () => {
    setIsVerifying(true)
    try {
      const login = await AuthApi.validarCodigo({ desafio, codigo })
      if (login && loginAutenticado(login)) {
        onVerified(login)
        return
      }

      notifyErrorFor('validar o código')
    } catch (error) {
      notifyErrorFor('validar o código', error)
    } finally {
      setIsVerifying(false)
    }
  }

  const reenviar = async () => {
    setIsResending(true)
    try {
      await AuthApi.enviarCodigo({ desafio })
      notifySuccess('Enviamos um novo código para o seu e-mail.')
    } catch (error) {
      notifyErrorFor('reenviar o código', error)
    } finally {
      setIsResending(false)
    }
  }

  return (
    <AuthLayout title="Verificação em duas etapas" subtitle={`Enviamos um código para ${email}`}>
      <form
        className={styles.form}
        onSubmit={(event) => {
          event.preventDefault()
          void validar()
        }}
      >
        <FormField label="Código de verificação" htmlFor="codigo" required>
          <Input
            id="codigo"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={6}
            placeholder="Preencha o código"
            value={codigo}
            onChange={(event) => setCodigo(event.target.value.replace(/\D/g, ''))}
          />
        </FormField>

        <Button type="submit" size="lg" block isLoading={isVerifying} disabled={codigo.length < 6}>
          Validar
        </Button>

        <div className={styles.actions}>
          <Button variant="ghost" size="sm" onClick={reenviar} isLoading={isResending}>
            Reenviar código
          </Button>
          <Button variant="ghost" size="sm" onClick={onCancel}>
            Voltar
          </Button>
        </div>
      </form>
    </AuthLayout>
  )
}

export default TwoFactor
